<template>
  <div class="banner_img" v-bind:style="{ backgroundImage: 'url(' + bannerImg + ')' }">
    <!--<img :src="bannerImg" alt="">-->
  </div>
</template>

<script>
export default {
  props: {
    bannerImg: {
      type: String,
    },
  },
};
</script>

<style></style>
